var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-website-group"},[_c('span',{class:['protocol-text', { 'danger' : _vm.dangerField }]},[_vm._v("\n        "+_vm._s(_vm.protocol)+"\n    ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }